/**
 * @generated SignedSource<<d6e54e96dce05a57acc305c838523af5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderDirection"
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountname",
        "variableName": "accountName"
      },
      {
        "kind": "Variable",
        "name": "appname",
        "variableName": "appName"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      {
        "kind": "Variable",
        "name": "orderby",
        "variableName": "orderBy"
      },
      {
        "kind": "Variable",
        "name": "orderdirection",
        "variableName": "orderDirection"
      }
    ],
    "concreteType": "AdminAppSummaryResultsConnection",
    "kind": "LinkedField",
    "name": "adminappsummarywithorderby",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminAppSummaryResult",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resellerCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subscriptionCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCharge",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "averageCharge",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminAppSummaryQuery",
    "selections": (v6/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdminAppSummaryQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "5a99e7836588edb0a40a4e07aca0180d",
    "id": null,
    "metadata": {},
    "name": "AdminAppSummaryQuery",
    "operationKind": "query",
    "text": "query AdminAppSummaryQuery(\n  $accountName: String\n  $appName: String\n  $orderBy: Int\n  $orderDirection: Int\n  $first: Int\n  $offset: Int\n) {\n  adminappsummarywithorderby(accountname: $accountName, appname: $appName, orderby: $orderBy, orderdirection: $orderDirection, first: $first, offset: $offset) {\n    totalCount\n    nodes {\n      accountId\n      accountName\n      appName\n      resellerCount\n      subscriptionCount\n      totalCharge\n      averageCharge\n    }\n  }\n}\n"
  }
};
})();

node.hash = "3bd18a0a191baa08391564d5717cccab";

module.exports = node;
